import React from "react"
import Layout from "./src/components/layout"

const transitionDelay = 400

// Muted, midtone hues only: low saturation keeps colors from reading as
// neon, and lightness pinned near 50% keeps them from going too light or dark.
const randomMutedHexColor = () => {
  const hue = Math.random() * 360
  const saturation = 20 + Math.random() * 20 // 20-40%
  const lightness = 45 + Math.random() * 10 // 45-55%

  const s = saturation / 100
  const l = lightness / 100
  const k = (n) => (n + hue / 30) % 12
  const a = s * Math.min(l, 1 - l)
  const f = (n) => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))
  const toHex = (x) => Math.round(255 * x).toString(16).padStart(2, "0")

  return `#${toHex(f(0))}${toHex(f(8))}${toHex(f(4))}`
}

const STATIC_FAVICON_HREF = "/images/Favicon.svg"

const applyRandomFavicon = (link) => {
  const innerFill = randomMutedHexColor()
  link.href = `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><rect width="32" height="32" rx="16" fill="#F6F6F6"/><rect x="10" y="10" width="12" height="12" fill="${innerFill}"/></svg>`,
  )}`
}

// Gatsby's Head export isn't hydrated (so an effect placed in seo.js never
// runs), and on every route change Gatsby rewrites <head> back to the SSR'd
// markup — clobbering a direct edit made here too. Watching for that rewrite
// and reapplying a fresh color right after is the only way it sticks.
const watchFavicon = () => {
  const observer = new MutationObserver(() => {
    const link = document.querySelector('link[rel="icon"]')
    if (link && link.getAttribute("href") === STATIC_FAVICON_HREF) {
      applyRandomFavicon(link)
    }
  })
  observer.observe(document.head, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["href"],
  })

  const initialLink = document.querySelector('link[rel="icon"]')
  if (initialLink) applyRandomFavicon(initialLink)
}

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}

// Left at its default, the browser also scrolls the page on its own on top of
// the scrollTo below — two things deciding scroll position on every
// navigation, with the browser's own one landing at no fixed time.
export const onClientEntry = () => {
  if ("scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual"
  }
  watchFavicon()
}

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.action === "PUSH") {
    window.setTimeout(() => window.scrollTo(0, 0), transitionDelay)
  } else {
    const savedPosition = getSavedScrollPosition(location)
    window.setTimeout(
      () => window.scrollTo(...(savedPosition || [0, 0])),
      transitionDelay,
    )
  }
  return false
}
